module.exports = __webpack_public_path__ + "static/c_4-970d7ead0b989785e4b056e748c61c95.jpg";